<script lang="ts">
    import type { FileInfo } from "$lib/wasm/db";
    import { onMount } from "svelte";

    export let file: FileInfo;
    let canvas: HTMLCanvasElement;

    onMount(() => {
        canvas.width = file.width;
        canvas.height = file.height;
        draw();
    });

    async function draw() {
        if (!canvas) return;
        if (!file?.render) return;

        // draw
        const u8_buffer = new Uint8ClampedArray(file.render.buffer);
        const result = new ImageData(
            u8_buffer as any,
            file.width,
            file.height,
        );

        const ctx = canvas.getContext("2d")!;
        ctx.putImageData(result, 0, 0);
    }
</script>

<!----------------------------------------------------------------------------->

<canvas bind:this={canvas}></canvas>

<!----------------------------------------------------------------------------->

<style>
    canvas {
        image-rendering: pixelated;
        object-fit: contain;
        background: var(--bgcanvas);
    }
</style>